<template>
    <div id="atelier-categories-tree" class="is-relative">
        <top-section>Atelier Categories</top-section>

        <b-loading :active="loading" :is-full-page="false"></b-loading>

        <portal to="sidebar">
            <div id="categories-tree" class="is-relative">
                <b-loading :active="treeLoading" :is-full-page="false"></b-loading>
                <p class="menu-label mt-4">Categories</p>
                <v-jstree :data="categories"
                          whole-row
                          @item-click="itemClick"
                ></v-jstree>
            </div>
        </portal>

        <div id="atelier-category-form" v-if="isCategorySelected">
            <accordion-section title="Main Information" startOpen>
                <b-field horizontal label="Name">
                    <b-input :value="selectedCategory.name" disabled type="text"></b-input>
                </b-field>
                <b-field horizontal label="Atelier Type">
                    <b-input :value="selectedCategory.atelier_type" disabled type="text"></b-input>
                </b-field>
                <b-field horizontal label="Atelier ID">
                    <b-input :value="selectedCategory.atelier_id" disabled type="text"></b-input>
                </b-field>
                <b-field horizontal label="Parent Name">
                    <b-input :value="selectedCategory.parent_name" disabled type="text"></b-input>
                </b-field>
                <b-field horizontal label="Parent ID">
                    <b-input :value="selectedCategory.parent_id" disabled type="text"></b-input>
                </b-field>
                <b-field horizontal label="Path">
                    <b-input :value="selectedCategory.path" disabled type="text"></b-input>
                </b-field>
            </accordion-section>

            <accordion-section title="Category Mapping" startOpen>
                <b-field horizontal label="Space Categories">
                    <b-taginput
                        :data="filteredCategories"
                        placeholder="Add a category"
                        field="name"
                        :allow-new="false"
                        autocomplete
                        open-on-focus @typing="getFilteredCategories" v-model="catsToSync">
                        <template slot-scope="props">
                            <strong v-text="getCategoryPath(props.option)"></strong> {{ props.option.name }}
                        </template>
                    </b-taginput>
                </b-field>

                <div class="section is-flex">
                    <b-button tag="button"
                              type="is-primary"
                              class="is-uppercase"
                              label="Sync Categories"
                              rounded style="margin-left: auto"
                              @click.prevent="submit"
                              outlined></b-button>
                </div>
            </accordion-section>
        </div>

        <div class="section" v-else>
            <b-notification
                type="is-warning"
                has-icon :closable="false">
                <p>Please select a category from the tree on the left.</p>
            </b-notification>
        </div>
    </div>
</template>
<script>
    import VJstree from 'vue-jstree';
    import _ from 'lodash'

    export default {
        components: {VJstree},
        data() {
            return {
                categories: [],
                selectedCategory: {},
                treeLoading: true,
                loading: true,
                spaceCategories: [],
                filteredCategories: [],
                catsToSync: []
            }
        },
        created() {
            axios.get('/atelierCategory/index')
            .then(response => {
                this.categories = response.data
                this.treeLoading = false
            })

            axios.get('/category/index')
                .then(response => {
                    this.spaceCategories = response.data
                    this.filteredCategories = response.data
                    this.loading = false;
                })
        },
        methods: {
            itemClick(node, item) {
                this.loading = true;
                axios.get(`/atelierCategory/edit/${item.id}`)
                .then(response => {
                    this.selectedCategory = response.data
                    this.catsToSync = response.data.catalog_categories
                    this.loading = false
                })
            },
            getCategoryPath(spaceCategory) {
                let path = spaceCategory.path.split('/')
                path.splice(-1,1);
                let prefix = ''
                for (let categoryId of path) {
                    let category = _.find(this.spaceCategories, {id: parseInt(categoryId)});
                    prefix += `${category.name} / `
                }
                return prefix;
            },
            getFilteredCategories(text) {
                this.filteredCategories = this.spaceCategories.filter((category) => {
                    return category.name
                        .toString()
                        .toLowerCase()
                        .indexOf(text.toLowerCase()) >= 0
                })
            },
            submit() {
                this.loading = true
                let category_ids = _.map(this.catsToSync, 'id');
                axios.post(`/category/atelier/sync/${this.selectedCategory.id}`, {category_ids})
                    .then(response => {
                        this.loading = false;
                        this.toaster("Categories correctly synced", 'is-success')
                    })
                    .catch(response => {
                        this.loading = false;
                        this.toaster("There was an error with your request", 'is-danger')
                    })
            },
            toaster(message, type) {
                this.$buefy.snackbar.open({
                    message,
                    type,
                    position: 'is-bottom-right',
                    actionText: 'Ok',
                })
            }
        },
        computed: {
            isCategorySelected() {
                return !_.isEmpty(this.selectedCategory)
            }
        }
    }
</script>